import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { Table, Tag, Typography, Card, Tooltip, Space, Button, Alert, App } from 'antd';
import { SafetyCertificateOutlined, ReloadOutlined } from '@ant-design/icons';
import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';
import { formatDateTime } from '@/lib/format';
import { verifyChain } from '@/lib/audit-verify';
export function AuditLogPage() {
    const { message } = App.useApp();
    const [verifying, setVerifying] = useState(false);
    const [verifyResult, setVerifyResult] = useState(null);
    const q = useQuery({
        queryKey: ['audit'],
        queryFn: async () => (await api.get('/audit', { params: { size: 200 } })).data,
    });
    const runVerify = async () => {
        if (!q.data)
            return;
        setVerifying(true);
        setVerifyResult(null);
        try {
            const rows = [...q.data];
            const result = await verifyChain(rows);
            setVerifyResult(result);
            if (result.ok) {
                message.success(`Rantai audit valid — ${result.totalChecked} baris terverifikasi`);
            }
            else {
                message.error(`Rantai audit RUSAK di seq=${result.firstBadSeq}`);
            }
        }
        finally {
            setVerifying(false);
        }
    };
    const cols = [
        { title: 'Seq', dataIndex: 'seq', width: 80 },
        {
            title: 'Waktu',
            dataIndex: 'ts',
            width: 170,
            render: (t) => formatDateTime(t),
        },
        {
            title: 'Aksi',
            dataIndex: 'action',
            render: (a) => _jsx(Tag, { color: "volcano", children: a }),
        },
        { title: 'Resource', dataIndex: 'resource_type', width: 130 },
        {
            title: 'Hash',
            dataIndex: 'hash',
            width: 140,
            render: (h) => (_jsx(Tooltip, { title: h, children: _jsxs("code", { children: [h.slice(0, 10), "\u2026"] }) })),
        },
        {
            title: 'Prev Hash',
            dataIndex: 'prev_hash',
            width: 140,
            render: (h) => (_jsx(Tooltip, { title: h, children: _jsxs("code", { style: { opacity: 0.6 }, children: [h.slice(0, 10), "\u2026"] }) })),
        },
    ];
    return (_jsxs("div", { children: [_jsxs(Space, { style: { marginBottom: 16, display: 'flex', justifyContent: 'space-between' }, children: [_jsx(Typography.Title, { level: 3, style: { margin: 0 }, children: "Audit Log" }), _jsxs(Space, { children: [_jsx(Button, { icon: _jsx(ReloadOutlined, {}), onClick: () => q.refetch(), children: "Muat Ulang" }), _jsx(Button, { type: "primary", icon: _jsx(SafetyCertificateOutlined, {}), loading: verifying, onClick: runVerify, children: "Verifikasi Integritas" })] })] }), verifyResult && (_jsx(Alert, { type: verifyResult.ok ? 'success' : 'error', showIcon: true, closable: true, onClose: () => setVerifyResult(null), style: { marginBottom: 16 }, message: verifyResult.ok
                    ? `Integritas terverifikasi — SHA-256 hash chain valid untuk ${verifyResult.totalChecked} baris.`
                    : `Integritas GAGAL di seq=${verifyResult.firstBadSeq}`, description: verifyResult.ok ? (_jsx("span", { children: "Setiap baris dihitung ulang di browser Anda dan cocok dengan hash yang tersimpan di server. Data audit tidak diubah." })) : (verifyResult.reason) })), _jsxs(Card, { children: [_jsxs(Typography.Paragraph, { type: "secondary", style: { marginTop: 0 }, children: ["Setiap perubahan data sensitif (jurnal, kontrak, penonaktifan pengguna, tutup buku) direkam sebagai satu baris ", _jsx("em", { children: "append-only" }), " dengan hash SHA-256 yang mengikat baris ke pendahulunya. Klik ", _jsx("b", { children: "Verifikasi Integritas" }), " untuk menghitung ulang seluruh rantai di browser Anda dan memastikan tidak ada baris yang diubah."] }), _jsx(Table, { rowKey: "seq", loading: q.isLoading, dataSource: q.data ?? [], columns: cols, size: "middle", pagination: { pageSize: 25 }, expandable: {
                            expandedRowRender: (r) => (_jsx("pre", { style: { margin: 0, fontSize: 12, background: '#FAF7F5', padding: 12, borderRadius: 6 }, children: JSON.stringify(r.payload, null, 2) })),
                        } })] })] }));
}
